import actions from "./actions";

export const LIST_RENDER = "list.rendered";

export default {
  ...actions,
};



// WEBPACK FOOTER //
// ./assets/list/constants/index.js